import PrimaryButton from '@/components/atoms/primaryButton/primaryButton'
import { useTranslate } from '@/i18n/useTranslate'

export type UnavailableService = 'betting' | 'gaming'

export type ServiceUnavailableModalProps = {
    // When non-null, the dialog is shown for the given service. Null hides it.
    service: UnavailableService | null
    onClose: () => void
}

const VCASH_URL = 'https://vcash.rs/lokacije.html'

export default function ServiceUnavailableModal({
    service,
    onClose
}: ServiceUnavailableModalProps) {
    const { t } = useTranslate()

    if (!service) {
        return null
    }

    return (
        <div className="service-unavailable-modal" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="title">
                    {t('welcome.dark.unavailableModal.title')}
                </h2>
                <p className="message">
                    {t(`welcome.dark.unavailableModal.${service}`)}
                </p>
                <img
                    className="qr-code"
                    src={`https://vqr-generator.fly.dev/api/vcash-print?data=${VCASH_URL}`}
                    alt="VCash QR Code"
                />
                <PrimaryButton
                    text={t('welcome.dark.unavailableModal.dismiss')}
                    callback={onClose}
                />
            </div>
        </div>
    )
}
